import { faker } from '@faker-js/faker';

export const randomBrand = {
  colors: [faker.color.rgb(), faker.color.rgb(), faker.color.rgb()],
  logo: faker.image.url(),
};
